import { render, staticRenderFns } from "./BPaginator.vue?vue&type=template&id=1e65001c"
import script from "./BPaginator.vue?vue&type=script&lang=js"
export * from "./BPaginator.vue?vue&type=script&lang=js"
import style0 from "./BPaginator.vue?vue&type=style&index=0&id=1e65001c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports